import { useState } from "react";
import CreateRoom from "../home/CreateRoom";
import Login from "../home/Login";
import PopupModal from '../home/PopupModal';
import { isLoggedIn } from "../../helper/access";

function ScheduleComponent({ showSchedulePopup = false, closeSchedulePopup }) {
    const [isLogged, setIsLogged] = useState(isLoggedIn());
    const [showRoom, setShowRoom] = useState(false);

    const showRoomPopUp = (val) => {
        if (val && val === true) {
            setShowRoom(true);
        }
    }
    return (
        <PopupModal
            isOpen={showSchedulePopup}
            onClose={closeSchedulePopup}
        >
            {(isLogged || showRoom) && <CreateRoom />}
            {(!isLogged && !showRoom) && <Login flowType={"show_room"} showRoomPopUp={showRoomPopUp} />}
        </PopupModal>
    );
}

export default ScheduleComponent;